export const AGE_GROUPS = ["Infant", "Toddler", "Two's", "Pre-K", "VPK", "Kindergarten", "First Grade", "Second Grade", "Third Grade", "Fourth Grade", "Fifth Grade"];

export const ROLE_CONFIG = {
  admin: { label: "Admin", color: "#E8852E", bg: "#FFF0DB", desc: "Full access to everything" },
  teacher: { label: "Teacher", color: "#4CAF7D", bg: "#E3F5EC", desc: "Own classroom attendance & view" },
  parent: { label: "Parent", color: "#3498DB", bg: "#DBEAFE", desc: "View own child's info & messages" },
  viewer: { label: "View Only", color: "#8B7E6A", bg: "#F5EFE4", desc: "View & download only" },
};
export const canEdit = (user) => user?.role === "admin";
export const canEditAttendance = (user, classroomId) => user?.role === "admin" || (user?.role === "teacher" && user?.assignedRoom === classroomId);
export const canView = () => true;

export const ACTIVITY_TYPES = [
  { id: "meal", icon: "meal", label: "Meal", details: ["Breakfast", "AM Snack", "Lunch", "PM Snack", "Bottle"], color: "#E8852E" },
  { id: "nap", icon: "nap", label: "Nap", details: ["Fell asleep", "Woke up", "Resting"], color: "#7C4DFF" },
  { id: "diaper", icon: "diaper", label: "Diaper", details: ["Wet", "Soiled", "Dry", "Potty"], color: "#00BCD4" },
  { id: "learning", icon: "learning", label: "Learning", details: ["Reading", "Writing", "Math", "Science", "Art", "Music", "Social Studies"], color: "#3498DB" },
  { id: "activity", icon: "activity", label: "Activity", details: ["Outdoor Play", "Indoor Play", "Circle Time", "Free Play", "Group Activity", "Field Trip"], color: "#4CAF7D" },
  { id: "medicine", icon: "medicine", label: "Medicine", details: ["Administered as prescribed", "Sunscreen applied", "First aid"], color: "#E74C3C" },
  { id: "milestone", icon: "milestone", label: "Milestone", details: ["First steps", "New word", "Shared with friend", "Learned new skill", "Self-care achievement"], color: "#F39C12" },
  { id: "mood", icon: "mood", label: "Mood", details: ["Happy", "Calm", "Fussy", "Tired", "Excited", "Shy"], color: "#E91E63" },
  { id: "note", icon: "note", label: "Note", details: [], color: "#8B7E6A" },
];


export const ENROLLMENT_STAGES = [
  { id: "inquiry", label: "Inquiry", color: "#9b59b6", icon: "mail" },
  { id: "waitlist", label: "Waitlist", color: "#e67e22", icon: "clock" },
  { id: "tour_scheduled", label: "Tour Scheduled", color: "#3498db", icon: "clock" },
  { id: "tour_complete", label: "Tour Complete", color: "#2980b9", icon: "check" },
  { id: "application", label: "Application", color: "#f39c12", icon: "daily-log" },
  { id: "enrolled", label: "Enrolled", color: "#27ae60", icon: "students" },
  { id: "withdrawn", label: "Withdrawn", color: "#95a5a6", icon: "arrow-left" },
];

